import { observable, action, computed, asStructure } from "mobx";
import debounce from "lodash.debounce";

export default class AppState {
  menu = observable({
    open: false,
    type: null
  });
  ticks = observable({
    time: 0
  });
  backgrounds = observable({
    primary: "INITIAL"
  });
  page = observable({
    currentPage: "INITIAL",
    currentTop: 0,
    currentBottom: 99999,
    progress: 0
  });
  constructor() {
    if (typeof window !== "undefined") {
      setInterval(() => (this.ticks.time = this.ticks.time + 200), 200);
    }
  }

  updateBackground = action(
    "UPDATE_BACKGROUND",
    background => (this.backgrounds.primary = background)
  );

  toggleMenu = action("TOGGLE_MENU", t => {
    const body = document.querySelector("body"); // Using a class instead, see note below.
    body.classList.toggle("js_open");
    this.menu.open = !this.menu.open;
    this.menu.type = t;
  });
}



// WEBPACK FOOTER //
// ./src/store/app.js